import { renderText, manageStatusCircle } from './constants';
import { Images } from '../../utils';
import { SimpleTooltip } from '../tooltip';
import React from 'react';

export const StatusCard = ({ status, text, custom, noCircle }) => {
    // const { backgroundColor, circleColor, color } = manageStatusCircle(status);
    const { backgroundColor, circleColor, color } = custom || manageStatusCircle(status);

    return (
        <div className="status-card-box" style={{ backgroundColor: backgroundColor }}>
            {!noCircle && <div className="status-card-circle" style={{ backgroundColor: circleColor }} />}
            <p style={{ color: color }}>{`${renderText(status)}${text ? text : ''}`}</p>
        </div>
    );
};

export const NonBillable = ({ noText, noIcon, toolText, style = {}, wrapperStyles = {} }) => {
    return (
        <>
            {toolText ? (
                <SimpleTooltip title={toolText} placement="top">
                    <div className="non-billable-box" style={{ ...wrapperStyles, padding: noText ? '4px' : '4px 12px' }}>
                        {!noIcon && <img src={Images.nonBilAble} alt="nonBillable" />}
                        {!noText && <p style={{ ...style }}>Non-billable</p>}
                    </div>
                </SimpleTooltip>
            ) : (
                <div className="non-billable-box" style={{ ...wrapperStyles, padding: noText ? '4px' : '4px 12px' }}>
                    {!noIcon && <img src={Images.nonBilAble} alt="nonBillable" />}
                    {!noText && <p style={{ ...style }}>Non-billable</p>}
                </div>
            )}
        </>
    );
};
